require('../../../modules/es.array.reduce');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').reduce;